export const APP_NAME = 'SmartSíndico';

export const BRAND_COLOR = '#135f9b';

export const API_URL = process.env.REACT_APP_API_URL as string;
export const GRAPHQL_API = process.env.REACT_APP_API_GRAPHQL_URL as string;
export const MOCK_API_URL = process.env.REACT_APP_MOCK_API_URL as string;
export const TOKEN_API = process.env.REACT_APP_TOKEN as string;
export const DASHBOARD_API = process.env.REACT_APP_API_DASH as string;
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN as string;
export const MAPBOX_GEOCODING_API = process.env.REACT_APP_GEOCODING_API as string;
export const GOOGLE_MAPS_TOKEN = process.env.REACT_APP_GOOGLE_MAPS_API as string;
export const SENTRY_TOKEN = process.env.REACT_APP_SENTRY_TOKEN as string;
export const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT as string;

export const ENVIROMENT = process.env.NODE_ENV;

export const DEFAULT_PUBLIC_PAGE = '/entrar';

export const DEFAULT_PRIVATE_PAGE = '/';

export const ACCESS_TOKEN_ID = '_smart-sindico_access';
export const REFRESH_TOKEN_ID = '_smart-sindico_refresh';
export const USER_INFO_ID = '_smart-sindicouser-info';

export const MSW_DB = '_smart-sindico_msw-db';

export const JWT_ACCESS_SECRET = '123456' as string;
export const JWT_ACCESS_EXPIRES_IN = 10;
export const JWT_REFRESH_SECRET = '123456789' as string;
export const JWT_REFRESH_EXPIRES_IN = 50;
